import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { RoundIcon, RoundIconVariants } from '@components/atoms/RoundIcon';
import { Typography, TypographyTagVariants } from '@components/atoms/Typography';
import { Anchor, AnchorMode } from '@components/atoms/Anchor';
import { Container } from '@components/atoms/Container';
import { useData } from '@hooks/useData';
import styles from './ContactsSection.module.css';
import { isPtMobilePhone } from '@utils/helper';

export const ContactsSection: FC = () => {
    const { t } = useTranslation();
    const { allSettings } = useData();

    const translations = {
        ptMobilePhoneNetworkDisclaimer: t('pt-mobile-phone-network-disclaimer'),
    };

    // Data from API
    const data = allSettings?.data;

    const showLocalCallNote: boolean = data?.phone && isPtMobilePhone(data.phone) ? true : false;

    return (
        <section className={`${styles['contacts-section']} bg-secondary text-center`}>
            <Container classes="py-5">
                <div className="row gy-5 g-lg-5 py-lg-5 justify-content-center align-items-center">
                    {data?.location && (
                        <div className="col-6 col-lg-3">
                            <i className={`${styles['icon']} fa-thin fa-location-dot`}></i>
                            <Typography tagVariant={TypographyTagVariants.p} classes="mb-0">
                                {data?.location}
                            </Typography>
                            <Typography tagVariant={TypographyTagVariants.p} classes="mb-0">
                                {data?.locationComplement}
                            </Typography>
                        </div>
                    )}

                    {data?.phone && (
                        <div className="col-6 col-lg-3">
                            <i className={`${styles['icon']} fa-thin fa-phone-volume`}></i>
                            <Typography tagVariant={TypographyTagVariants.p} classes="mb-0">
                                {data?.phone}
                            </Typography>
                            {showLocalCallNote && (
                                <Typography classes="mb-0" fontSize="12">
                                    {translations.ptMobilePhoneNetworkDisclaimer}
                                </Typography>
                            )}
                        </div>
                    )}

                    {data?.email && (
                        <div className="col-6 col-lg-3">
                            <i className={`${styles['icon']} fa-thin fa-envelope`}></i>
                            <Typography tagVariant={TypographyTagVariants.p} classes="mb-0">
                                {data?.email ? (
                                    <Anchor mailTo={data?.email} mode={AnchorMode.none}>
                                        {data?.email}
                                    </Anchor>
                                ) : (
                                    <span></span>
                                )}
                            </Typography>
                        </div>
                    )}

                    {data?.social_networks && (
                        <div className="col-6 col-lg-3">
                            <i className={`${styles['icon']} fa-thin fa-heart`}></i>
                            <div>
                                <ul className="nav d-inline-flex justify-content-center">
                                    {data.social_networks.map(
                                        (socialNetwork, index) =>
                                            socialNetwork.url && (
                                                <li className="mb-2 px-2" key={index}>
                                                    <Anchor href={socialNetwork.url} target="_blank" mode={AnchorMode.none}>
                                                        <RoundIcon
                                                            icon={socialNetwork.icon}
                                                            variant={RoundIconVariants.variant1}
                                                        />
                                                    </Anchor>
                                                </li>
                                            )
                                    )}
                                </ul>
                            </div>
                        </div>
                    )}
                </div>
            </Container>
        </section>
    );
};
